// src/contacts/index.js — 📇 Contacts (v129.39). The company phone book.
//
// Matt, 4 Aug: "'Contacts' - this will have all e-mail addresses and phone
// numbers of stores and Head Office it should also link to 'chat now' (our
// internal chat tool) and 'call now' our internal call (if they have an
// account). There are people that dont have accounts. but we should set up
// anyway. … We should also have a link to jack and say 'Have you asked Jack
// first?'"
//
// The Jack prompt sits at the TOP, before the directory, because that is the
// whole point of it: most of the reasons somebody reaches for this screen
// ("what time does Dubai Mall open", "who do I send a damaged stock form to")
// are questions Jack already answers, and once you have found a phone number
// you are not going to go back and try the chatbot instead.
//
// Every action shown is one the Worker has said WILL work — see
// src/worker/contacts.js. A directory with a dead "Chat now" button is worse
// than one without it, because the reader stops trusting the whole screen.

var _data = null;
var _q = '';
var _tab = 'stores';   // 'stores' | 'ho'

function api(path, opts) {
  opts = opts || {};
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  var headers = { 'Content-Type': 'application/json' };
  var tk = (typeof DB !== 'undefined' && DB.getToken) ? DB.getToken() : null;
  if (tk) headers['Authorization'] = 'Bearer ' + tk;
  return fetch(base + path, { method: opts.method || 'GET', headers: headers, body: opts.body, cache: 'no-store' });
}
function esc(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
// v132.89 (overnight audit): stripping quotes AFTER esc removed nothing, because
// esc had already turned ' into &#39;, which the browser decodes back to a
// quote before an inline handler runs. JS-escape first, THEN HTML-escape.
function jsArg(s) {
  return esc(String(s == null ? '' : s).replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\r?\n/g, '\\n'));
}
function myStore() {
  try { return (typeof currentStore !== 'undefined' && currentStore) ? (currentStore.name || currentStore) : null; } catch (e) { return null; }
}
function root() { return document.getElementById('contactsRoot'); }

// ── the search ──────────────────────────────────────────────────────────────
// Mirrors matchesQuery in the Worker core: name, department, title, email and
// the NUMBERS — typing "1234567" should find a colleague without knowing their name,
// which is how people actually use a phone book they half-remember.
function matches(e, q) {
  var s = String(q || '').trim().toLowerCase();
  if (!s) return true;
  var hay = [e.name, e.department, e.job_title, e.email, e.extension,
    e.mobile_label, e.phone_label, e.country].filter(Boolean).join(' ').toLowerCase();
  var digits = s.replace(/\D/g, '');
  if (digits.length >= 3 && hay.replace(/\D/g, '').indexOf(digits) !== -1) return true;
  return hay.indexOf(s) !== -1;
}

// "📹 Call Alex" fits a phone-width row; "📹 Call Alex Van Example" wraps
// and pushes the other buttons off. The full name is already the card heading
// directly above the button, so the first word is unambiguous here.
function firstName(name) {
  var s = String(name || '').trim();
  if (!s) return 'them';
  return s.split(/\s+/)[0];
}

// ── one action button ───────────────────────────────────────────────────────
function act(label, onclick, tone) {
  var bg = tone === 'green' ? 'var(--elc-green,#009E3D)' : 'var(--card)';
  var fg = tone === 'green' ? '#fff' : 'var(--text)';
  var bd = tone === 'green' ? 'transparent' : 'var(--border,#dde3e8)';
  return '<button onclick="' + onclick + '" style="border:1px solid ' + bd + ';background:' + bg +
    ';color:' + fg + ';font-weight:700;font-size:12.5px;padding:8px 12px;border-radius:10px;' +
    'cursor:pointer;font-family:inherit;white-space:nowrap">' + label + '</button>';
}

// tel:/mailto: are plain links — on a phone they dial and compose, which is the
// entire point for the ~40 people with no Shift login.
function telBtn(dial, label) {
  if (!dial) return '';
  return '<a href="tel:' + esc(dial) + '" style="text-decoration:none;border:1px solid var(--border,#dde3e8);' +
    'background:var(--card);color:var(--text);font-weight:700;font-size:12.5px;padding:8px 12px;border-radius:10px;' +
    'display:inline-block;white-space:nowrap">📞 ' + esc(label) + '</a>';
}

function storeCard(s) {
  var actions = [];
  if (s.phone) actions.push(telBtn(s.phone, s.phone_label));
  if (s.email) actions.push(act('📧 Email', "Contacts.emailStore('" + jsArg(s.email) + "')"));
  if (s.chat_channel) actions.push(act('💬 Chat now', "Contacts.chat('" + jsArg(s.chat_channel) + "','" + jsArg(s.name) + "')"));
  if (s.call_store) actions.push(act('📹 Call now', "Contacts.callStore('" + jsArg(s.name) + "')", 'green'));
  return '<div style="background:var(--card);border:1px solid var(--border,#dde3e8);border-radius:12px;padding:12px 14px;margin-bottom:8px">' +
    '<div style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap">' +
      // v135.1: names, addresses and numbers are never translated.
      '<div style="font-weight:800;font-size:14px" translate="no">' + esc(s.name) + '</div>' +
      (s.is_me ? '<span style="font-size:11px;color:var(--comms-brand-text);font-weight:700">your store</span>' : '') +
    '</div>' +
    (s.email ? '<div style="font-size:12px;color:var(--ui-ink-2);margin-top:2px" translate="no">' + esc(s.email) + '</div>' : '') +
    (!s.phone ? '<div style="font-size:11.5px;color:var(--comms-orange-ink);margin-top:4px">No landline recorded yet — Head Office can add it in Admin.</div>' : '') +
    (actions.length ? '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px">' + actions.join('') + '</div>' : '') +
    '</div>';
}

function personCard(p) {
  // v129.51 (Matt: "give everyone that has uploaded a picture a face on the
  // Contacts tab") — the avatar chip renders initials immediately and the
  // Avatars sweep swaps in the uploaded photo where one exists (acct-<id> key
  // space, fetched on demand — photos stay OFF /api/sync, the load-bearing
  // rule). Only LINKED people can have an account photo; everyone else keeps
  // the tasteful initials disc, which is still a face-shaped thing rather
  // than a wall of identical cards.
  var face = '';
  try {
    if (typeof Avatars !== 'undefined' && Avatars.chip) {
      face = p.account_id
        ? Avatars.chip('account', p.account_id, p.name, 40)
        : Avatars.chip('staff', null, p.name, 40) || '';
      // chip() refuses a null id by design — fall back to a plain initials disc
      if (!face) {
        face = '<span translate="no" style="display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background:var(--comms-face);color:var(--ui-ink-2);font-size:15px;font-weight:800;flex-shrink:0">' + esc(String(p.name || '?').trim().slice(0, 1).toUpperCase()) + '</span>';
      }
    }
  } catch (e) { /* face is garnish */ }
  var actions = [];
  if (p.extension_dial) actions.push(telBtn(p.extension_dial, 'Ext ' + p.extension));
  if (p.mobile) actions.push(telBtn(p.mobile, p.mobile_label));
  if (p.email) actions.push(act('📧 Email', "Contacts.emailStore('" + jsArg(p.email) + "')"));
  if (p.chat_channel) actions.push(act('💬 Chat now', "Contacts.chat('" + jsArg(p.chat_channel) + "','" + jsArg(p.name) + "')"));
  // v129.41 — this rings THEM, so it says their name. (v129.39 read "Call Head
  // Office" because the only account-side ring target was the shared queue;
  // migration v185 gave every account holder their own line.)
  if (p.call_account_id) {
    actions.push(act('📹 Call ' + esc(firstName(p.name)),
      'Contacts.callPerson(' + Number(p.call_account_id) + ",'" + jsArg(p.name) + "')", 'green'));
  }
  var sub = [p.job_title, p.is_line ? null : null].filter(Boolean).join(' · ');
  return '<div style="background:var(--card);border:1px solid var(--border,#dde3e8);border-radius:12px;padding:12px 14px;margin-bottom:8px' +
    (p.is_line ? ';opacity:.75' : '') + '">' +
    '<div style="display:flex;align-items:center;gap:10px">' + face +
    '<div style="font-weight:800;font-size:14px" translate="no">' + esc(p.name) + '</div></div>' +
    (sub ? '<div style="font-size:12px;color:var(--ui-ink-2);margin-top:1px" translate="no">' + esc(sub) + '</div>' : '') +
    (p.email ? '<div style="font-size:12px;color:var(--ui-ink-2);margin-top:2px" translate="no">' + esc(p.email) + '</div>' : '') +
    (actions.length
      ? '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px">' + actions.join('') + '</div>'
      : '<div style="font-size:11.5px;color:var(--comms-hint);margin-top:6px">No number or address recorded.</div>') +
    '</div>';
}

function jackCardHtml() {
  return '<div style="background:var(--info-bg);border:1.5px solid var(--comms-info-line);border-radius:12px;padding:12px 14px;margin-bottom:14px;' +
    'display:flex;align-items:center;gap:12px;flex-wrap:wrap">' +
    '<div style="font-size:24px">🤖</div>' +
    '<div style="flex:1;min-width:180px">' +
      '<div style="font-weight:800;font-size:14px">Have you asked Jack first?</div>' +
      '<div style="font-size:12px;color:var(--comms-info-ink);line-height:1.45;margin-top:2px">' +
        'Jack knows the policies, the opening hours, who covers what and most of what you were about to ring up and ask.' +
      '</div>' +
    '</div>' +
    act('Ask Jack', 'Contacts.askJack()', 'green') +
    '</div>';
}

export function render() {
  var el = root(); if (!el) return;
  if (!_data) { el.innerHTML = '<div style="padding:24px;text-align:center;color:var(--ui-ink-2)">Loading contacts…</div>'; load(); return; }
  if (_data.error) {
    el.innerHTML = '<div style="padding:16px;border:1px solid var(--comms-red-line);background:var(--comms-red-soft);border-radius:10px;color:var(--comms-err)">' +
      'Could not load contacts — ' + esc(_data.error) + '</div>';
    return;
  }

  var stores = (_data.stores || []).filter(function (s) { return matches(s, _q); });
  var groups = (_data.head_office || []).map(function (g) {
    return { label: g.label, people: (g.people || []).filter(function (p) { return matches(p, _q); }) };
  }).filter(function (g) { return g.people.length; });
  var hoCount = groups.reduce(function (n, g) { return n + g.people.length; }, 0);

  var tabBtn = function (id, label, n) {
    var on = _tab === id;
    return '<button onclick="Contacts.tab(\'' + id + '\')" style="border:none;background:' +
      (on ? 'var(--elc-green,#009E3D)' : 'var(--card)') + ';color:' + (on ? '#fff' : 'var(--text)') +
      ';font-weight:800;font-size:13px;padding:9px 16px;border-radius:10px;cursor:pointer;font-family:inherit">' +
      label + ' <span style="opacity:.7;font-weight:600">' + n + '</span></button>';
  };

  var body;
  if (_tab === 'stores') {
    body = stores.length
      ? stores.map(storeCard).join('')
      : '<div style="padding:24px;text-align:center;color:var(--ui-ink-2)">No stores match that search.</div>';
  } else if (_data.contacts_unavailable) {
    // "Nobody at Head Office" and "the read broke" must never look the same —
    // the v129.18 APL lesson.
    body = '<div style="padding:16px;border:1px solid var(--comms-orange-line);background:var(--comms-orange-bg);border-radius:10px;color:var(--comms-orange-ink);font-size:13px">' +
      esc(_data.contacts_error || 'The Head Office list is not available yet.') + '</div>';
  } else {
    body = groups.length
      ? groups.map(function (g) {
        return '<div style="font-size:11px;font-weight:800;color:var(--ui-ink-2);text-transform:uppercase;letter-spacing:.04em;padding:12px 2px 6px">' +
          esc(g.label) + '</div>' + g.people.map(personCard).join('');
      }).join('')
      : '<div style="padding:24px;text-align:center;color:var(--ui-ink-2)">No one at Head Office matches that search.</div>';
  }

  el.innerHTML =
    '<div style="padding:4px 2px 10px">' +
    jackCardHtml() +
    '<input id="contactsSearch" type="search" value="' + esc(_q) + '" placeholder="🔍 Search a name, store, department or number" ' +
      'oninput="Contacts.search(this.value)" style="width:100%;box-sizing:border-box;padding:11px 13px;border:1.5px solid var(--border,#dde3e8);' +
      'border-radius:11px;font-family:inherit;font-size:14px;margin-bottom:10px">' +
    '<div style="display:flex;gap:8px;margin-bottom:12px">' +
      tabBtn('stores', '🏪 Stores', stores.length) + tabBtn('ho', '🏢 Head Office', hoCount) +
    '</div>' +
    body +
    '</div>';
  var s = document.getElementById('contactsSearch');
  if (s && _q) { try { s.focus(); s.setSelectionRange(_q.length, _q.length); } catch (e) { /* not focusable yet */ } }
  // v129.51 — hydrate the uploaded photos into the chips just rendered.
  try { if (typeof Avatars !== 'undefined' && Avatars.sweep) Avatars.sweep(); } catch (e) { /* initials stay */ }
}

export async function load(force) {
  if (_data && !force) return;
  try {
    var st = myStore();
    var res = await api('/api/contacts' + (st ? '?store=' + encodeURIComponent(st) : ''));
    var d = await res.json().catch(function () { return {}; });
    _data = (res.ok && d && d.ok) ? d : { error: (d && d.error) || ('HTTP ' + res.status) };
  } catch (e) {
    _data = { error: (e && e.message) || 'check the connection' };
  }
  render();
}

export function search(v) { _q = String(v || ''); render(); }
export function tab(t) { _tab = t; render(); }

// ── the actions ─────────────────────────────────────────────────────────────
// Each hands off to the feature that already owns it rather than reimplementing
// it here: one chat, one call overlay, one email composer.
export function chat(channel, title) {
  try {
    if (typeof switchScreen === 'function') switchScreen('chat');
    if (typeof Chat !== 'undefined' && Chat.startDm && String(channel).indexOf('acct:') === 0) {
      Chat.startDm(channel, title); return;
    }
    if (typeof Chat !== 'undefined' && Chat.openChannel) { Chat.openChannel(channel, title); return; }
    if (typeof showToast !== 'undefined') showToast('Open the Chat tab to message ' + title);
  } catch (e) {
    if (typeof showToast !== 'undefined') showToast('Could not open that chat');
  }
}

export async function callStore(name) {
  if (typeof Calls === 'undefined' || !Calls.dial) {
    if (typeof showToast !== 'undefined') showToast('Calls are not available on this device yet — reload the app');
    return;
  }
  Calls.dial(name);
}

// v129.41 — ring one person's devices. Kept as its own export (rather than
// overloading callStore) so the card markup says what it means, and so an older
// bundle without Calls.dialPerson degrades to a toast instead of silently
// ringing the whole of Head Office.
export async function callPerson(accountId, name) {
  if (typeof Calls === 'undefined' || !Calls.dialPerson) {
    if (typeof showToast !== 'undefined') showToast('Calls are not available on this device yet — reload the app');
    return;
  }
  Calls.dialPerson(accountId, name);
}

// mailto:, deliberately — NOT the in-app composer. Chat.composeEmail takes a
// REPLY id, not an address (src/chat/index.js:903), so handing it an address
// would open a blank compose and look like the button had misfired. A mailto:
// opens the device's mail app with the address already in the To field, which
// is what "Email" promises. Wiring the in-app composer to accept a fresh
// recipient is a separate change to that module, not something to fake here.
export function emailStore(address) {
  try { window.location.href = 'mailto:' + address; }
  catch (e) { if (typeof showToast !== 'undefined') showToast(address); }
}

export function askJack() {
  try {
    if (typeof switchScreen === 'function') switchScreen('chat');
    if (typeof Chat !== 'undefined' && Chat.openJack) { Chat.openJack(); return; }
    if (typeof showToast !== 'undefined') showToast('Open 💬 Chat and tap Ask Jack');
  } catch (e) {
    if (typeof showToast !== 'undefined') showToast('Open 💬 Chat and tap Ask Jack');
  }
}
